import { Attr, BelongsTo, HasMany, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";
import Employer from "./Employer";
import LeagueTableAgency from "./LeagueTableAgency";

@Model()
class LeagueTable extends ApplicationRecord {
  static jsonapiType = "league_tables";

  @Attr() companyId: number;

  @BelongsTo(Employer) employer: Employer;

  @HasMany(LeagueTableAgency) leagueTableAgencies: LeagueTableAgency[];
}

export default LeagueTable;
